export class BackupZeroEtlFilters {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "allowedTables",
            "baseName": "allowedTables",
            "type": "Array<BackupZeroEtlTableFilter>",
            "format": ""
        },
        {
            "name": "selection",
            "baseName": "selection",
            "type": "BackupZeroEtlTableSelection",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return BackupZeroEtlFilters.attributeTypeMap;
    }
    constructor() {
    }
}
